import * as stylex from "@stylexjs/stylex";
import { getFocusMetadata } from "focus-content";
import { pipe } from "fp-ts/lib/function";
import useLocale from "hooks/useLocale";
import { Article16 } from "icons/Article";
import { E } from "prelude";
import { RAliasTheme, subthemesIndex } from "routes";
import { focusArticles } from "../../focus";
import { colors } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
import { PageLink } from "./links";
const styles = {
    linkText: {
        kUk6DE: "x98rzlu",
        kVQacm: "xb3r6kr",
        k1xSpc: "x104kibb",
        kJFfOR: "x1h7i4cw",
        kgKLqz: "x1ua5tub",
        $$css: true
    }
};
export function FocusThemeList({ theme }) {
    const locale = useLocale();
    const focusArticlesTheme = pipe(theme, RAliasTheme.decode, E.fold(()=>[], (themeAlias)=>{
        const subthemes = subthemesIndex[themeAlias];
        return focusArticles.published.map((focus)=>getFocusMetadata(focus, locale)).filter((focus)=>subthemes.includes(focus.article)).sort((a, b)=>a.year - b.year);
    }));
    return <div>
      {focusArticlesTheme.map((article)=>{
        return <PageLink name={article.alias} key={article.alias}>
            <span className="xh8yej3 x78zum5 x167g77z x7a106z x1ypdohk x1saejgb x87ps6o x9a8edp x268jtm">
              <Article16 className="x12klvby xr9ek0c x1kky2od xlup9mm"/>
              <p {...stylex.props(typography.table, styles.linkText)}>{article.title}</p>
            </span>
          </PageLink>;
    })}
    </div>;
}
